import { IonButton, IonIcon, IonItem, IonLabel } from "@ionic/react";
import { helpCircle } from "ionicons/icons";
import { useHelpStore } from "../stores/help.store";

interface Props {
  id?: string;
  title?: string;
}

const HelpButton: React.FC<Props> = ({ id, title }) => {
  const { setIsHelpOpen, setActiveHelpId } = useHelpStore(state => state);

  const handleHelpClick = () => {
    if (id) {
      setActiveHelpId(id);
      setIsHelpOpen(true);
    }
  };

  return (
    <>
      {title ? (
        <IonItem button onClick={handleHelpClick}>
          <IonLabel>{title}</IonLabel>
          <IonIcon icon={helpCircle} slot="end" color="tertiary" />
        </IonItem>
      ) : (
        <IonButton fill="clear" onClick={handleHelpClick}>
          <IonIcon icon={helpCircle} className="icon-only" color="tertiary" />
        </IonButton>
      )}
    </>
  );
};

export default HelpButton;
